import { object, string, boolean } from 'yup';
import { TFunction } from 'i18next';

export function makeBusinessPartnerInfoSchema(t: TFunction) {
  return object().shape({
    a: string().required(t('form.required')),
    b: string().required(t('form.required')),
    c: string().required(t('form.required')),
    d: boolean().required(t('form.required')),
    e: string(),
    f: string(),
    g: string(),
    h: string(),
  });
}
